import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { getMyTicket } from "../../services/ticketService";

const Ticket = () => {
  const { reference } = useParams();
  const [booking, setBooking] = useState(null);
  const [verifyUrl, setVerifyUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyTicket(reference)
      .then((data) => {
        setBooking(data.booking);
        setVerifyUrl(data.verify_url);
      })
      .catch(() => setError("টিকেট পাওয়া যায়নি। পেমেন্ট কনফার্ম হয়েছে কিনা চেক করুন।"))
      .finally(() => setLoading(false));
  }, [reference]);

  return (
    <React.Fragment>
      <Header parentMenu="my-tickets" activeMenu="/my-tickets" />
      <SiteBreadcrumb pageTitle="My Ticket" pageName="My Ticket" breadcrumbsImg={bannerbg} />

      <section style={{ padding: "80px 0" }}>
        <div className="container" style={{ maxWidth: 480 }}>
          {loading && <p>লোড হচ্ছে...</p>}
          {error && <p style={{ color: "#e6394f" }}>{error}</p>}

          {booking && (
            <div
              style={{
                border: "1px dashed #999",
                borderRadius: 12,
                padding: 28,
                textAlign: "center",
              }}
            >
              <h3 style={{ marginTop: 0 }}>{booking.event?.title}</h3>
              <p>{booking.ticket_type?.name} × {booking.quantity}</p>
              <p style={{ fontWeight: 600 }}>{booking.booking_reference}</p>

              <div style={{ display: "flex", justifyContent: "center", margin: "24px 0" }}>
                <QRCodeSVG value={verifyUrl || booking.booking_reference} size={200} />
              </div>

              <p style={{ color: "#666", fontSize: 14 }}>
                Gate এ QR কোড স্ক্যান করলেই এই টিকেট verify হবে।
              </p>
              <p style={{ fontWeight: 700, color: "#1aa053" }}>
                Status: {booking.status === "confirmed" ? "Confirmed ✓" : booking.status}
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Ticket;
